import {
  RESOURCE_MANAGEMENT_DATA,
  RESOURCE_MANAGEMENT_DATA_SUCCESS,
  RESOURCE_MANAGEMENT_DATA_FAIL,
  RESOURCE_MANAGEMENT_VIEW,
  RESOURCE_MANAGEMENT_VIEW_SUCCESS,
  RESOURCE_MANAGEMENT_VIEW_FAIL,
  RESOURCE_MANAGEMENT_DELETE,
  RESOURCE_MANAGEMENT_DELETE_SUCCESS,
  RESOURCE_MANAGEMENT_DELETE_FAIL
} from "../Constants/ResourceManagementConstant";

const initialState = {
  resourceLoading: false,
  resourceSuccess: [],
  resourceViewLoading: false,
  resourceViewSuccess: [],
  resourceDelete: false,
  resourceDeleteLoading: false
};

export default function ResourceManagementReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case RESOURCE_MANAGEMENT_DATA:
      return {
        ...state,
        resourceLoading: true,
      };
    case RESOURCE_MANAGEMENT_DATA_SUCCESS:
      return {
        ...state,
        resourceLoading: false,
        resourceSuccess: action.payload,
      };
    case RESOURCE_MANAGEMENT_DATA_FAIL:
      return {
        ...state,
        resourceLoading: false,
        resourceSuccess: [],
      };

    case RESOURCE_MANAGEMENT_VIEW:
      return {
        ...state,
        resourceViewLoading: true,
      };
    case RESOURCE_MANAGEMENT_VIEW_SUCCESS:
      return {
        ...state,
        resourceViewLoading: false,
        resourceViewSuccess: action.payload,
      };
    case RESOURCE_MANAGEMENT_VIEW_FAIL:
      return {
        ...state,
        resourceViewLoading: false,
        resourceViewSuccess: [],
      };
    case RESOURCE_MANAGEMENT_DELETE:
      return {
        ...state,
        resourceDeleteLoading: true,
        resourceDelete: true,
      };
    case RESOURCE_MANAGEMENT_DELETE_SUCCESS:
      return {
        ...state,
        resourceDeleteLoading: false,
        resourceDelete: false,
      };
    case RESOURCE_MANAGEMENT_DELETE_FAIL:
      return {
        ...state,
        resourceDeleteLoading: false,
        resourceDelete: false,
      };
    default:
      return state;
  }
}
